import { isBrowser } from '@axo/shared/util/dom';

export const clearCrossDomainAuthRouteToken = (): void => {
  if (!isBrowser()) return;

  const hash = window.location.hash?.slice(1) ?? '';
  const hashParams = new URLSearchParams(
    hash.includes('&') ? hash : `?${hash}`
  );
  const urlParams = new URLSearchParams(window.location.search);

  const applicationId = urlParams.get('id');
  const token = hashParams.get('token');

  // Cross Domain Auth consists of a combination of the application id and the token.
  // If either is missing, we don't clear the token.
  if (!(applicationId && token)) return;

  // clear both if the combination is valid, this to avoid conflicts with magic-token on mypage
  urlParams.delete('id');
  hashParams.delete('token');

  const newSearch = urlParams.toString() ? `?${urlParams.toString()}` : '';
  const newHash = hashParams.toString() ? `#${hashParams.toString()}` : '';

  window.history.replaceState(
    {},
    document.title,
    `${window.location.pathname}${newSearch}${newHash}`
  );
};
